<template>
    <kt-row style="padding-right: 25px;display: block" v-if="all_services && service_wages && service_providers">
        <div v-for="(service,index) in all_services" v-bind:key="index">
            <kt-row>
                <kt-col lg="2" md="2" sm="6" xs="12" style="margin-top: 34px">
                    <p>
                        {{ $t('application.services.' + services[index]) }}
                    </p>
                </kt-col>
                <kt-col lg="10" md="10" sm="6" xs="12">
                    <div v-for="(bank, index) in getServiceBanks(service)" v-bind:key="bank">
                        <kt-row>
                            <kt-col lg="6" md="6" sm="6" xs="12">
                                <kt-form-group ref="bank">
                                    <kt-form-label for="bank">
                                        {{ $t('label.bank') }}
                                    </kt-form-label>
                                    <kt-form-control
                                        :value="bankIdStr.get(bank)"
                                        disabled
                                        :id="index"></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="4" md="4" sm="6" xs="12">
                                <kt-form-group ref="provider">
                                    <kt-form-label for="provider">
                                        {{ $t('application.provider') }}
                                    </kt-form-label>
                                    <kt-form-select id="provider" class="form-control"
                                                    :name="service+'_'+bank+'_provider'"
                                                    v-model="service_wages[service][bank].provider"
                                    >
                                        <option value=""></option>
                                        <option
                                            v-bind:key="provider"
                                            v-for="provider in getServiceBankProvider(service, bank)"
                                            v-bind:value="provider"
                                        >
                                            {{ providerTypeStr.get(provider) }}
                                        </option>
                                    </kt-form-select>
                                </kt-form-group>
                            </kt-col>
                        </kt-row>
                        <kt-row v-show="service_wages[service][bank].provider">
                            <kt-col lg="2" md="2" sm="6" xs="12">
                                <h6 style="font-weight: bold;padding-top: 30px">{{ $t('application.company_wage') }}</h6>
                            </kt-col>
                            <kt-col
                                v-show="Object.values(changeableWageServices).includes(service)"
                                lg="2" md="2" sm="6" xs="12">
                                <kt-form-group ref="bank">
                                    <kt-form-label for="company_wage_type">
                                        {{ $t('label.wage_type') }}
                                    </kt-form-label>
                                    <kt-form-select size="5" id="wage_type" class="form-control"
                                                    :name="service+'_'+bank+'_company_wage_type'"
                                                    v-model="service_wages[service][bank].company_wage_type"
                                    >
                                        <option value=""></option>
                                        <option
                                            v-bind:key="index"
                                            v-for="(wage, index) in filteredWageTypes(service)"
                                            v-bind:value="wage.value"
                                            :selected="wage.value"
                                        >
                                            {{ wage.title }}
                                        </option>
                                    </kt-form-select>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="2" md="2" sm="6" xs="12"
                                    v-show="service_wages[service][bank].company_wage_type || !Object.values(changeableWageServices).includes(service)">
                                <kt-form-group>
                                    <kt-form-label :for="index" v-if="service_wages[service][bank].company_wage_type == 1 || !Object.values(changeableWageServices).includes(service)">
                                        {{ $t('application.inquiry_price') }}
                                    </kt-form-label>
                                    <kt-form-label v-else :for="index">
                                        {{ $t('application.wage_percent') }}
                                    </kt-form-label>
                                    <kt-form-control dir="ltr" type="number"
                                                     :name="service+'_'+bank+'_company_wage'"
                                                     :id="index"
                                                     v-model="service_wages[service][bank].company_wage"
                                    ></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="2" md="2" sm="6" xs="12"
                                    v-show="service_wages[service][bank].company_wage_type == 2">
                                <kt-form-group>
                                    <kt-form-label :for="index">
                                        {{ $t('application.min_wage_amount') }}
                                    </kt-form-label>
                                    <kt-form-control dir="ltr" type="number"
                                                     :id="index"
                                                     :name="service+'_'+bank+'_company_min_wage'"
                                                     v-model="service_wages[service][bank].company_min_wage"
                                    ></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="2" md="2" sm="6" xs="12"
                                    v-show="service_wages[service][bank].company_wage_type == 2">
                                <kt-form-group>
                                    <kt-form-label :for="index">
                                        {{ $t('application.max_wage_amount') }}
                                    </kt-form-label>
                                    <kt-form-control dir="ltr" type="number"
                                                     :id="index"
                                                     :name="service+'_'+bank+'_company_max_wage'"
                                                     v-model="service_wages[service][bank].company_max_wage"
                                    ></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                        </kt-row>
                        <kt-row v-show="service_wages[service][bank].provider">
                            <kt-col lg="2" md="2" sm="6" xs="12">
                                <h6 style="font-weight: bold;padding-top: 30px">{{ $t('application.provider_wage') }}</h6>
                            </kt-col>
                            <kt-col
                                v-show="Object.values(changeableWageServices).includes(service)"
                                lg="2" md="2" sm="6" xs="12">
                                <kt-form-group ref="bank">
                                    <kt-form-label for="provider_wage_type">
                                        {{ $t('label.wage_type') }}
                                    </kt-form-label>
                                    <kt-form-select size="5" id="provider_wage_type" class="form-control"
                                                    :name="service+'_'+bank+'_provider_wage_type'"
                                                    v-model="service_wages[service][bank].provider_wage_type"
                                    >
                                        <option value=""></option>
                                        <option
                                            v-bind:key="index"
                                            v-for="(wage, index) in filteredWageTypes(service)"
                                            v-bind:value="wage.value"
                                            :selected="wage.value"
                                        >
                                            {{ wage.title }}
                                        </option>
                                    </kt-form-select>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="2" md="2" sm="6" xs="12"
                                    v-show="service_wages[service][bank].provider_wage_type || !Object.values(changeableWageServices).includes(service)">
                                <kt-form-group>
                                    <kt-form-label :for="index" v-if="service_wages[service][bank].provider_wage_type == 1 || !Object.values(changeableWageServices).includes(service)">
                                        {{ $t('application.inquiry_price') }}
                                    </kt-form-label>
                                    <kt-form-label v-else :for="index">
                                        {{ $t('application.wage_percent') }}
                                    </kt-form-label>
                                    <kt-form-control dir="ltr" type="number"
                                                     :name="service+'_'+bank+'_provider_wage'"
                                                     :id="index"
                                                     v-model="service_wages[service][bank].provider_wage"
                                    ></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="2" md="2" sm="6" xs="12"
                                    v-show="service_wages[service][bank].provider_wage_type == 2">
                                <kt-form-group>
                                    <kt-form-label :for="index">
                                        {{ $t('application.min_wage_amount') }}
                                    </kt-form-label>
                                    <kt-form-control dir="ltr" type="number"
                                                     :id="index"
                                                     :name="service+'_'+bank+'_provider_min_wage'"
                                                     v-model="service_wages[service][bank].provider_min_wage"
                                    ></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="2" md="2" sm="6" xs="12"
                                    v-show="service_wages[service][bank].provider_wage_type == 2">
                                <kt-form-group>
                                    <kt-form-label :for="index">
                                        {{ $t('application.max_wage_amount') }}
                                    </kt-form-label>
                                    <kt-form-control dir="ltr" type="number"
                                                     :id="index"
                                                     :name="service+'_'+bank+'_provider_max_wage'"
                                                     v-model="service_wages[service][bank].provider_max_wage"
                                    ></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                        </kt-row>
                        <hr v-if="index < getServiceBanks(service).length -1">
                    </div>
                </kt-col>
            </kt-row>
            <hr style="background-color: red">
        </div>
    </kt-row>
</template>

<script>
import {applicationServiceStatus, services, financialServices, providerTypeStr, changeableWageServices} from '@/constants/openBanking'
import {bankIdStr} from '@/constants/bankId'
import {i18n} from '@/plugins/i18n';

export default {
    props: {
        all_services: {
            required: true,
        },
        service_wages: {
            required: true,
        },
        service_providers: {
            required: true,
        },
    },
    computed: {
        bankIdStr() {
            return bankIdStr
        },
        filteredWageTypes() {
            return (service) => {
                return this.wage_types.filter(wage_type =>
                    Object.values(this.changeableWageServices).includes(service) || wage_type.value !== 2
                );
            };
        }
    },
    methods: {
        getServiceBankProvider(service, bank) {
            return this.service_providers[service][bank]
        },
        getServiceBanks(service) {
            return Object.keys(this.service_providers[service])
        },
        serviceHasBank(service) {
            return Object.values(this.financialServices).includes(service)
        }
    },
    data() {
        return {
            applicationServiceStatus,
            services,
            financialServices,
            providerTypeStr,
            changeableWageServices,
            wage_types: [
                {
                    title: i18n.t('gateway.wage_types.fixed'),
                    value: 1
                },
                {
                    title: i18n.t('gateway.wage_types.percent'),
                    value: 2
                },
            ]
        }
    }
}
</script>

<style>

</style>